import * as XLSX from 'xlsx';

export function generateExcelFromBase64(
  data: string,
  fileName = 'relatório.xlsx'
) {
  const binaryString = window.atob(data);
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);

  for (let i = 0; i < binaryLen; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  const fileData = bytes;

  const blob = new Blob([fileData], { type: 'application/octet-stream' });
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.style.display = 'none';
  link.download = fileName;
  link.click();
}

export function generateExcelFromBase64OrdersView(
  data: string,
  fileName = 'relatório.xlsx'
) {
  const binaryString = window.atob(data);
  const binaryLen = binaryString.length;
  const bytes = new Uint8Array(binaryLen);

  for (let i = 0; i < binaryLen; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }

  const workbook = XLSX.read(bytes, { type: 'array' });

  const sheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[sheetName];

  const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
  const colWidths = jsonData[0].map((_: any, colIndex: number) => {
    const maxLength = jsonData.reduce((max: number, row: any) => {
      const cellValue = row[colIndex] ? row[colIndex].toString() : '';
      return Math.max(max, cellValue.length);
    }, 0);
    return { wch: maxLength + 2 };
  });

  worksheet['!cols'] = colWidths;

  const excelData = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const excelBlob = new Blob([excelData], { type: 'application/octet-stream' });

  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(excelBlob);
  link.style.display = 'none';
  link.download = fileName;
  link.click();
}